<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>Top 5</h4>
            </div>
        </div>
        <div class="card-body">
            <DoughnutChart
                :data=chartData
                :options=chartOptions
                :height=350
                :plugins="[innerLabel]"
                >
            </DoughnutChart>
        </div>
    </b-card>
</template>

<script>
import CreateVueChart from '@/components/CreateVueChart.js'
import { ref, computed, getCurrentInstance } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'

export default {
    components: {
        DoughnutChart: CreateVueChart('Doughnut')
    },
    props: {
        pieChartData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props) {
        const vm = getCurrentInstance().proxy
        const saveHoveredIdx = (idx) => { hoveredIdx.value = idx }
        const hoveredIdx = ref(0)
        const innerLabel = computed(() => ({
            id: 'innerLabel',
            afterDatasetDraw (chart, args) {
                const { ctx } = chart
                const meta = args.meta
                if (!meta.data[0]) return
                const xCoor = meta.data[0]._view.x
                const yCoor = meta.data[0]._view.y
                ctx.save()
                ctx.textAlign = 'center'
                ctx.font = '15px sans-serif'
                ctx.fillStyle = '#595959'
                ctx.fillText(props.pieChartData.length ? chart.data.datasets[0].labels[hoveredIdx.value] : vm.$t('org.dashboard.no data'), xCoor, yCoor - 10)
                ctx.font = '18px sans-serif'
                ctx.fillText(`${props.pieChartData.length ? (chart.data.datasets[0].data[hoveredIdx.value] / totalCost.value * 100).toFixed() : '- '}%`, xCoor, yCoor + 20)
                ctx.restore()
            }
        }))
        const setTooltipText = (tooltipItem, data) => {
            const label = data.datasets[0].labels[tooltipItem.index] || ''
            const value = data.datasets[0].data[tooltipItem.index]
            const output = ` ${label} : ${vm.$_getDollar(value)}`
            return output
        }
        const setLabelText = () => {
            const sum = props.pieChartData.map(item => item.cost).reduce((prev, cur) => prev + cur, 0)
            const text = props.pieChartData.map(item => `${item.tagValue} (${Math.round(item.cost * 100 / sum)}%)`)
            return text
        }
        const totalCost = computed(() => {
            return props.pieChartData.map(item => item.cost).reduce((prev, cur) => prev + cur, 0)
        })
        const chartData = computed(() => ({
            labels: props.pieChartData.length ? setLabelText() : ['-', '-', '-', '-', '-'],
            datasets: [
                {
                    labels: props.pieChartData.length ? props.pieChartData.map(item => item.tagValue) : [],
                    data: props.pieChartData.length ? props.pieChartData.map(item => item.cost) : [0, 0, 0, 100, 0],
                    backgroundColor: [
                        '#ffe700',
                        '#FFA1A1',
                        '#2b9bf4',
                        '#826bf8',
                        '#00d4bd'
                    ],
                    borderWidth: [0.001, 0.001, 0.001, 0.001, 0.001],
                    pointStyle: 'rectRounded'
                }
            ]
        }))
        const chartOptions = computed(() => ({
            plugins: {
                datalabels: {
                    display: false
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            responsiveAnimationDuration: 500,
            cutoutPercentage: 65,
            legend: {
                fontColor: '#FFFFFF',
                position: 'bottom',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    padding: 20,
                    boxWidth: 9,
                    fontSize: 12,
                    fontColor: '#B4B4B4'
                }
            },
            tooltips: {
                enabled: props.pieChartData.length,
                callbacks: {
                    label: setTooltipText
                },
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowBlur: 80
            },
            onHover: function (e, el) {
                if (props.pieChartData.length) {
                    if (el.length && el[0]._index !== hoveredIdx.value) saveHoveredIdx(el[0]._index)
                }
            }
        }))
        return {
            $themeColors,
            innerLabel,
            chartData,
            chartOptions
        }
    }
}
</script>

<style>

</style>
